export const SpinnerLoading = () => {
  return (
    <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex align-items-center justify-content-center z-index-1">
      <div className="bg-white rounded p-4 shadow d-flex align-items-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="ms-3 text-muted">Processing...</div>
      </div>
    </div>
  );
};
